import Typography from "@mui/material/Typography";
import useNav from "core/hooks/useNav";

import Box from "ui/atom/Box";
import Icon from "ui/atom/Icon";
import Button from "ui/base/Button";
import Page from "ui/Page";


export default function NotFound() {
	const nav = useNav();
	return (
		<Page>
			<Page.Body sx={{ mt: 5, alignItems: "center" }}>
				<Icon name="search-x" size={72} />
				<Box.Column gap={0.5} sx={{ alignItems: "center", textAlign: "center" }}>
					<Typography variant="h1">Campaign not found</Typography>
					<Typography>The campaign you’re looking for doesn’t exist or is no longer available.</Typography>
				</Box.Column>
				<Button variant="outlined" color="secondary" sx={{ mt: 2 }} onClick={nav.back}>Go back</Button>
			</Page.Body>
		</Page>
	);
}